import { Empty, Segmented } from 'antd';
import React from 'react';
import classes from './TranscriptionTab.module.scss';
import { useTranslation } from 'react-i18next';
import api from 'api';
import { useAppSelector } from 'store/hook';
import Spinner from 'components/Spinner/Spinner';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { setTranscriptionText } from 'store/slices/aiFunctionsDataSlice';

type TranscriptionProps = {};

const Transcription = ({}: TranscriptionProps) => {
  const [currentSegment, setCurrentSegment] = React.useState('transcription');
  const [downloadingFileWithTranscription, setDownloadingFileWithTranscription] = React.useState(false);
  
  const { transcription, transcriptionText, sessionStatus } = useAppSelector((state) => state.aiFunctions);
  const { messageApi } = useAppSelector((state) => state.windowState);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const getText = async () => {
    setDownloadingFileWithTranscription(true);
    try {
      const file = await api.getTranscriptionFile(transcription?.document_id!);
      // const result = await file.data.text();
      dispatch(setTranscriptionText(file.data)); 
    } catch (e) {
      messageApi?.error(t('Documents.details.transcription.errorGettingTranscription'))
    } finally {
      setDownloadingFileWithTranscription(false);
    }    
  }

  React.useEffect(() => {
    !transcriptionText && getText();
  },[])
  
  const segmentOptions = [
    { value: 'transcription', label: t('Documents.details.transcription.segment_full') },
    { value: 'summary', label: t('Documents.details.transcription.segment_summary') },
  ];

  const content = {
    transcription: downloadingFileWithTranscription
      ? (
        <div className={cn(classes.holder, classes.shortHeight)}>
          <Spinner size={60} withLogo={true} height={60}/>
          <div className={classes.text}>{t(`Documents.details.transcription.${sessionStatus ? 'uploading_status' : 'uploading'}`)}</div>
        </div>
      )
      : (
        <div className={classes.transcription}>{transcriptionText || (
          <Empty
            className={classes.noTrascription}
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<span>{t('Documents.details.transcription.empty')}</span>}
          />
        )}</div>
      ),
    summary: (
      <div className={classes.transcription}>{transcription?.summary || (
        <Empty
          className={classes.noTrascription}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={<span>{t('Documents.details.transcription.empty')}</span>}
        />
      )}</div>
    )
  }

  return (
    <div style={{height: '100%'}}>
      <Segmented
        className={classes.segmenWrap}
        options={segmentOptions}
        block
        value={currentSegment}
        onChange={(value) => setCurrentSegment(value)}
      />
      {content[currentSegment as keyof typeof content]}
    </div>
  );
}

export default Transcription;
